import styles from './PillBadge.module.scss'

const SIZE_VARS = {
  tiny:   { 
    '--bim-data-value-size': '0.75em', 
    '--bim-data-badge-height': '1.5em' 
  },
  small:  { 
    '--bim-data-value-size': '1em',   
    '--bim-data-badge-height': '2em' 
  },
  normal: { 
    '--bim-data-value-size': '1.25em', 
    '--bim-data-badge-height': '2.5em' 
  },
  large:  { 
    '--bim-data-value-size': '1.5em', 
    '--bim-data-badge-height': '3em' 
  },
}

/**
 * PillBadge — styled inline badge with background.
 *
 * Uses the shared `--bim-data-value-size` CSS var for its font-size so that
 * it stays visually consistent with DataItem values when rendered in the
 * same tile context.
 *
 * The `size` prop injects `--bim-data-*` vars on the badge element itself,
 * so it can be sized independently of any ancestor DataGrid.
 *
 * @param {object}   props
 * @param {string}  props.value                - Text content of the badge
 * @param {'tiny'|'small'|'normal'|'large'} [props.size] - Typography scale; omit to inherit from ancestor
 * @param {string}  [props.className]            - Extra class on root element
 */
export function PillBadge({ 
  value, 
  size = 'small', 
  className = '', 
}) {
  const sizeStyle = SIZE_VARS[size] ?? null 

    return (
      <span
        style={sizeStyle}
        className={[
          styles.badge,
          className,
        ].filter(Boolean).join(' ')}
      >
        {value}
      </span>
    )
}